import { useOptionalUrlTiles } from '../../../url-tiles';

/** The open tile that `isPayload` recognises and that belongs to the task, if any. */
export const useOpenTileOfTask = <Payload extends { readonly taskId: string }>(
    isPayload: (payload: unknown) => payload is Payload,
    taskId: string,
): Payload | undefined => {
    const payloads = useOptionalUrlTiles()?.tiles.map(({ payload }) => payload) ?? [];

    for (const payload of payloads) {
        if (isPayload(payload) && payload.taskId === taskId) {
            return payload;
        }
    }

    return undefined;
};
